import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'
import { Collapse, message } from 'antd'
import Spin from '../../../../components/Spin'
import ChatForm from './ChatForm'
import {
  editForm,
  fetchItem,
  createItem,
  editItem,
  deleteItem,
  reset,
} from '../../../../actions/sellerChatForm'

const { Panel } = Collapse

const storeKey = 'sellerChatForm'

class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleFormOnSubmit = this.handleFormOnSubmit.bind(this)
    this.handleFormOnDelete = this.handleFormOnDelete.bind(this)
    this.props.reset()
  }

  componentDidMount() {
    if (this.props.type === 'edit') {
      this.props.fetchItem({
        sellerId: this.props.seller.idnum,
        sellerToken: this.props.seller.s_token,
        messengerType: this.props.chat.n_type,
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreateItemLoading && nextProps.isCreateItemSuccess) {
      message.success('Новый чат-бот для торговой сети успешно создан.')
      this.props.onReload()
      this.props.setActiveChat({ idnum: null }, false)
    } else if (this.props.isEditItemLoading && nextProps.isEditItemSuccess) {
      message.success('Данные чат-бота для торговой сети успешно изменен.')
      this.props.onReload()
    } else if (this.props.isDeleteItemLoading && nextProps.isDeleteItemSuccess) {
      message.success('Чат-бот для торговой сети успешно удален.')
      this.props.onReload()
      this.props.setActiveChat({ idnum: null }, false)
    } else if (this.props.isCreateItemLoading && nextProps.createItemError) {
      message.error(nextProps.createItemError)
    } else if (this.props.isEditItemLoading && nextProps.editItemError) {
      message.error(nextProps.editItemError)
    } else if (this.props.isDeleteItemLoading && nextProps.deleteItemError) {
      message.error(nextProps.deleteItemError)
    } else if (this.props.isFetchItemLoading && nextProps.fetchItemError) {
      message.error(nextProps.fetchItemError)
    }
  }

  handleFormOnSubmit(values) {
    const item = { ...this.props.item, ...values }
    if (this.props.type === 'create') {
      this.props.createItem({
        ...item,
        sellerId: this.props.seller.s_token,
        maxbonusSellerId: this.props.seller.idnum,
        sellerName: this.props.seller.s_name,
        seller: { ...this.props.seller },
      })
    } else {
      this.props.editItem({
        ...item,
        sellerId: this.props.seller.idnum,
        sellerToken: this.props.seller.s_token,
      })
    }
  }

  handleFormOnDelete() {
    this.props.deleteItem({
      apiToken: this.props.item.apiToken,
      sellerId: this.props.seller.idnum,
    })
  }

  render() {
    const {
      type, chat,
    } = this.props

    const isCreateForm = type === 'create'
    const actionTitle = isCreateForm ? 'Создать' : 'Управление'

    return (
      <div>
        {
              this.props.isFetchItemLoading && <Spin />
        }
        {
              (isCreateForm || (!isCreateForm && this.props.item)) &&
              <ChatForm
                onSubmit={this.handleFormOnSubmit}
                onDelete={this.handleFormOnDelete}
                onFieldsChange={this.props.editForm}
                formFieldValues={this.props.formFieldValues}
                isCreateItemLoading={this.props.isCreateItemLoading}
                isEditItemLoading={this.props.isEditItemLoading}
                isDeleteItemLoading={this.props.isDeleteItemLoading}
                type={this.props.type}
                chat={chat}
              />
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    formFieldValues,
    isFetchItemLoading,
    isEditItemLoading,
    isCreateItemLoading,
    isCreateItemSuccess,
    isEditItemSuccess,
    isDeleteItemLoading,
    isDeleteItemSuccess,
    item,
    fetchItemError,
    createItemError,
    editItemError,
    deleteItemError,
  } = state[storeKey]

  return {
    isFetchItemLoading,
    formFieldValues,
    isEditItemLoading,
    isCreateItemLoading,
    isCreateItemSuccess,
    isEditItemSuccess,
    isDeleteItemLoading,
    isDeleteItemSuccess,
    item,
    fetchItemError,
    createItemError,
    editItemError,
    deleteItemError,
  }
}

const mapDispatchToProps = dispatch => ({
  createItem: params => dispatch(createItem(params)),
  editItem: params => dispatch(editItem(params)),
  fetchItem: params => dispatch(fetchItem(params)),
  deleteItem: params => dispatch(deleteItem(params)),
  editForm: formFieldsChange => dispatch(editForm(formFieldsChange)),
  reset: () => dispatch(reset()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ItemForm))



// WEBPACK FOOTER //
// src/containers/SellerForm/ChatList/Form/index.jsx